import Login from './login/en_EN'
import Entity from './entity/en_EN'
import Home from './home/en_EN'
import Adherent from './adherent/en_EN'
import Correspondant from './correspondant/en_EN'
import Document from './document/en_EN'
import Fiche from './fiche/en_EN'
import Mutation from './mutation/en_EN'
import Assistance from './assistance/en_EN'
import Utilisateur from './user/en_EN'
import Question from './questionsecrete/en_EN'
import Password from './password/en_EN'
import Registration from './registration/en_EN'
import Forgot from './forgot/en_EN'
import Gestionnaire from './gestionnaire/en_EN'

const basic = {
  lead: 'Welcome to your application',
  locale: {
    fr_FR: 'FR',
    en_EN: 'EN',
  },
  from: 'Start date',
  to: 'End date',
  search: 'Search',
  list: {
    title: 'LST - {0}',
  },
  menu: {
    title: 'Menu',
    home: 'Home',
    default: 'Extra<b>ciem</b>',

    dashboard: 'dashboard',

    administratif: 'Administrative',
    adherents: {
      etablissement: 'My members',
    },
    documents: 'My medical record',
    mutation: 'Participant transfer',
    assistance: 'Assistance',
    participantCoordonnes: 'My contact details',
    fichesConseil: 'My advice sheets',
    morrespondants: 'My correspondents',
    particupantsRendezVous: 'My Appointments',
    politiqueProtectionDonnees: 'Data protection policy',
  },
  auth: {
    error: 'Unable to reach the authorization server',
    unauthorized: 'Invalid login or password',
    connected: 'You are now connected',
    disconnected: 'You are now disconnected',
    notLogged: 'Please login to access this function',
    accessDenied: "You don't have permission to access this function",
    confirmation: {
      expired: 'The code you just entered has expired',
      notfount: 'The information you entered is incorrect',
    },
    tokenException: 'The connection is no longer active, please reconnect.',
    reactivate: 'DMC activation passed successfully',
  },
  errors: {
    required: 'This field is required',
    minLength: 'Minimum length {0} characters',
    maxLength: 'Maximum length {0} characters',

    provenanceValidator: 'The origin of the participant is not correct',
    email: 'Email type field',
    missmatch: 'Passwords must be identical',
    passwordRegles: 'the password does not respect all the rules',
    emailNotValid: 'The email address entered is not correct',
    portableNonValide: 'The cell phone entered is not valid',
  },
  form: {
    error: 'Please correct your entry',
    saved: 'This entity has been saved',
    deleted: 'This entity has been deleted',
    deletedList: 'Deleted entity (ies)',
    reloaded: 'This entity has been reload',
    updatedBy: 'This entity has been updated by  #%{principal}',
    deleteAll:
      '|Would you like to delete this entity ?|Would you like to delete these #%{count} entities ?',
    deactivateAll:
      '|Do you want to deactivate this entity? | Do you want to deactivate these #%{count} entities ?',
    auditHistory: 'Audit modifications',
  },
  button: {
    submit: 'Submit',
    confirm: 'confirm',
    create: 'Create',
    save: 'Save',
    send: 'Send',
    cancel: 'Cancel',
    accueil: 'Return to Home',
    new: 'New',
    non: 'No',
    oui: 'Yes',
    delete: 'Delete',
    deactivate: 'Deactivate',
    reload: 'Reload',
    showHistory: 'Show history',
    modify: 'Modify',
    confirmation: 'Confirm',
    resilier: 'Terminate',
    adherer: 'adhere',
    close: 'Close',
    valider: 'Validate',
    display: 'Display',
    accept: 'Accept',
    next: 'Next',
  },
  boolean: {
    true: 'Yes',
    false: 'No',
  },
  table: {
    paginate: 'Showing items {startsAt} to {endsAt} of {totalRows}',
    noData: 'No data availlable',
  },
  modal: {
    delete: 'Delete',
  },

  authConfirm: {
    message:
      'A code has been sent to your mobile phone, please enter it to continue your authentication',
    codeConfirmation: 'Confirmation code',
  },
  error: {
    technique: {
      essenciem:
        'A technical error in the EssenCIEM software has occurred, please contact support for more information.',
      extraciem:
        'A technical error in the ExtraCIEM software has occurred, please contact support for more information.',
    },
  },
}

const lang = Object.assign(
  basic,
  Login,
  Entity,
  Adherent,
  Home,
  Correspondant,
  Document,
  Fiche,
  Mutation,
  Assistance,
  Utilisateur,
  Question,
  Password,
  Registration,
  Forgot,
  Gestionnaire,
)
export default lang
